<template>
    <ValidationObserver
        ref="inlineEditing"
        v-slot="{ passes }"
    >
    <!-- Dialog Header : Quelle von Liste -->
        <BaseDialog
            :showDialog="showDialog"
            :close="closeDialog"
            persistent
            :headline="getHeadline"
            :alvqa="alvqa"
            maxDialogWidth="800"
            maxCardHeight="800"
        >
            <template v-slot:dialogText>
                <v-container fluid> 
                    <v-row>
                        <v-col cols="3">
                            <BaseEditPageTextField 
                                :context="context"
                                field="ConversionFactor"
                                :label="$t('lang_PUBLISHING_INCOME_CAPTION_CCF')" 
                                :withMargin="false"
                                :clearable="true"
                                :alvqa="alvqa + '-textfield-list-conversion-factor'"
                                rules="wuf|notZero"
                            />
                        </v-col>
                        <v-col cols="3" v-if="listPageContext === 'Income'">
                            <BaseEditPageTextField 
                                :context="context"
                                field="ListNo"
                                :label="$t('lang_GENERIC_CAPTION_LIST_NUMBER')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-list-number'"
                            />
                        </v-col>
                        <v-col cols="3" v-if="listPageContext === 'Income' || listPageContext === 'SalesData'">
                            <!-- validation: number -->
                            <BaseEditPageTextField 
                                :context="context"
                                field="CommissionPercent"
                                :label="$t('lang_PUBLISHING_INCOME_CAPTION_COMMISSION_PERCENT')"
                                :withMargin="false"
                                :clearable="true"
                                :alvqa="alvqa + '-textfield-list-commission-percent'"
                                suffix="%"
                                rules="percent3Decimals"
                            />
                        </v-col>
                    </v-row>
                        <BasePeriod 
                            :context="context"
                            periodLabel="lang_GENERIC_CAPTION_PERIOD"
                            :undefinedTimeUnit="true"
                            classNumber="pr-3"
                            classYear="pr-3"
                        />
                </v-container>
            </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                label="lang_GENERAL_BUTTON_SAVE"
                                :disabled="isLoading"
                                @click="passes(save)"
                                :alvqa="alvqa + '-button-save'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BasePeriod from '@/components/_base/BasePeriod'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: "InlineEditingListPageDialog",
    props: {
        listPageContext: String
    },
    components: {
        BaseDialog,
        BasePeriod,
        BaseButton,
        BaseEditPageTextField
    },
    data() {
        return {
            alvqa: "inline-editing-listpage-dialog",
            context: this.listPageContext + "InlineEditingDialog"
        }
    },
    computed: {
        getHeadline() {
            let item = this.$store.getters['get' + this.listPageContext].find(element => {
                return element.alvId === this.$store.getters['getSelected' + this.listPageContext]
            })

            if(item === undefined) return ''
            else return this.$t("lang_GENERAL_CAPTION_EDIT_LISTPAGE_DIALOG_EDIT_METADATA") + ': ' + item.source
        },
        showDialog: {
            get() { return this.$store.getters.getShowInlineEditingDialog },
            set(show) { this.$store.commit('setShowInlineEditingDialog', show)}
        },
        isLoading() {
            if(this.listPageContext == 'SalesData'){
                return this.$store.getters.getIsLoading;
            }
            return false;
        },
        showListNumber() { return this.$store.getters['get' + this.listPageContext + 'InlineEditingDialogDetails'].showListNumber },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelected' +  this.listPageContext, [])
            this.$store.commit('set' + this.listPageContext + 'InlineEditingDialogDetails', {})
            this.$store.commit('setSelectedPeriodValues' + this.listPageContext + 'InlineEditingDialog', { num: null, period: "notDefined", year: null})
        },
        save() {
            this.$store.dispatch('save' + this.listPageContext + 'EditDialog')
        }
    },
    created() {
        let defaults = this.$store.getters['get' + this.listPageContext + 'InlineEditingDialogDefault']
        this.$store.commit('set'+ this.listPageContext +'InlineEditingDialogDetails', defaults)
    }
}
</script>